import React, { useEffect, useRef } from "react";
import { FaHeart, FaTrash, FaUser, FaSearch } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

function Header({
  loggedInUser,
  accountOpen,
  setAccountOpen,
  favOpen,
  setFavOpen,
  dropdownOpen,
  setDropdownOpen,
  getCart,
  getFavorites,
  handleLogout,
  removeFromCart,
  removeFavorite,
  handleCheckout,
  setUserData,
  setGuestCart,
  toggleFavorite,
  onSearch,
}) {
  const cartRef = useRef();
  const favRef = useRef();
  const accountRef = useRef();
  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    if (onSearch) onSearch(e.target.value);
  };

  const handleClearCart = () => {
    if (loggedInUser) {
      const id = loggedInUser.id;
      setUserData((prev) => ({
        ...prev,
        [id]: { ...prev[id], cart: [] },
      }));
    } else {
      setGuestCart([]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cartRef.current && !cartRef.current.contains(event.target))
        setDropdownOpen(false);
      if (favRef.current && !favRef.current.contains(event.target))
        setFavOpen(false);
      if (accountRef.current && !accountRef.current.contains(event.target))
        setAccountOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setDropdownOpen, setFavOpen, setAccountOpen]);

  return (
    <nav
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",               // ← *CLAVE PARA MÓVIL*
        padding: "10px 20px",           // ← menos padding, cabe en móvil
        background: "#F4DDD6",
        position: "sticky",
        top: 0,
        zIndex: 100
      }}
    >

      {/* LOGO */}
      <Link to="/" style={{ display: "flex", alignItems: "center"}}>
        <img
          src="/images/logo.png"
          alt="Logo Esencial"
          style={{
            height: "65px",
            objectFit: "contain",
            marginBottom: "10px"        // ← deja espacio al romper línea
          }}
        />
      </Link>

      {/* 🔍 BUSCADOR */}
      <form
        onSubmit={(e) => e.preventDefault()}
        style={{
          display: "flex",
          alignItems: "center",
          flex: "1 1 100%",             // ← ocupa ancho completo en móvil
          maxWidth: "450px",
          margin: "0 0 10px 0",
          background: "#fff",
          borderRadius: "30px",
          padding: "5px 15px",
        }}
      >
        <input
          type="text"
          placeholder="Buscar productos..."
          onChange={handleSearchChange}
          style={{
            flex: 1,
            border: "none",
            outline: "none",
            padding: "8px",
            borderRadius: "30px",
          }}
        />
        <FaSearch color="#333" size={18} />
      </form>

      {/* ICONOS */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          position: "relative",
          width: "100%",               // ← en móvil pasan abajo
          justifyContent: "flex-end"
        }}
      >

        {/* CUENTA */}
        <div
          ref={accountRef}
          style={{
            cursor: "pointer",
            fontSize: "24px",
            color: "#333",
            position: "relative",
          }}
          onClick={() => setAccountOpen(!accountOpen)}
        >
          <FaUser />

          {/* MENÚ NO LOGUEADO */}
          {accountOpen && !loggedInUser && (
            <div
              style={{
                position: "absolute",
                right: 0,
                top: "45px",
                backgroundColor: "#fff",
                borderRadius: "14px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                padding: "15px 25px",
                zIndex: 1000,
                minWidth: "260px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                textAlign: "center",
              }}
            >
              <p style={{
                fontWeight: "600",
                color: "#444",
                fontSize: "13px",
                marginBottom: "6px",
                letterSpacing: "0.3px",
              }}>
                ¡Bienvenido/a!
              </p>

              <Link
                to="/login"
                style={{
                  textDecoration: "none",
                  background: "#4B6CB7",
                  color: "white",
                  padding: "8px 0",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "13px",
                }}
              >
                Iniciar sesión
              </Link>

              <Link
                to="/register"
                style={{
                  textDecoration: "none",
                  background: "#f0f4ff",
                  color: "#4B6CB7",
                  padding: "8px 0",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "13px",
                }}
              >
                Registrarse
              </Link>
            </div>
          )}

          {/* MENÚ LOGUEADO */}
          {accountOpen && loggedInUser && (
            <div
              style={{
                position: "absolute",
                right: 0,
                top: "45px",
                backgroundColor: "#fff",
                borderRadius: "14px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                padding: "15px 25px",
                zIndex: 1000,
                minWidth: "260px",
                textAlign: "left",
              }}
            >
              <p
                style={{
                  marginBottom: "8px",
                  fontWeight: "bold",
                  color: "#333",
                  fontSize: "12px",
                  borderBottom: "1px solid #eee",
                  paddingBottom: "5px",
                  wordBreak: "break-all",
                }}
              >
                {loggedInUser.email}
              </p>

              <button
                onClick={() => navigate("/profile")}
                style={{
                  width: "100%",
                  padding: "8px",
                  backgroundColor: "#f0f4ff",
                  color: "#4B6CB7",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "6px",
                }}
              >
                Mi perfil
              </button>

              <button
                onClick={handleLogout}
                style={{
                  width: "100%",
                  padding: "8px",
                  backgroundColor: "#f28e8e",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "500",
                }}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>

        {/* FAVORITOS */}
        <div
          ref={favRef}
          style={{
            position: "relative",
            fontSize: "28px",
            cursor: "pointer",
            color: "#333",
          }}
          onClick={() => setFavOpen(!favOpen)}
        >
          <FaHeart color={getFavorites().length ? "red" : "#333"} />
          {getFavorites().length > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-10px",
                right: "-10px",
                background: "red",
                color: "white",
                borderRadius: "50%",
                padding: "4px 8px",
                fontSize: "14px",
              }}
            >
              {getFavorites().length}
            </span>
          )}

          {favOpen && (
            <div
              style={{
                position: "absolute",
                right: 0,
                top: "35px",
                width: "300px",
                maxHeight: "400px",
                overflowY: "auto",
                background: "white",
                color: "black",
                border: "1px solid #ccc",
                borderRadius: "5px",
                padding: "10px",
                zIndex: 1000,
              }}
            >
              <h4 style={{ marginTop: 0, fontSize: "14px" }}>Favoritos</h4>

              {getFavorites().length === 0 ? (
                <p style={{ fontSize: "12px" }}>No hay favoritos</p>
              ) : (
                getFavorites().map((item, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                      borderBottom: "1px solid #eee",
                      paddingBottom: "5px",
                    }}
                  >
                    <img
                      src={item.imagen}
                      alt={item.nombre}
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                        marginRight: "10px",
                        borderRadius: "5px",
                      }}
                    />
                    <div style={{ flex: 1 }}>
                      <p
                        style={{
                          margin: 0,
                          fontWeight: "bold",
                          fontSize: "12px",
                          color: "black",
                        }}
                      >
                        {item.nombre}
                      </p>
                      <p style={{ margin: 0, fontSize: "12px", color: "black" }}>
                        {(item.precio / 100).toFixed(2)} €
                      </p>
                    </div>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        removeFavorite(item.nombre);
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "red",
                        cursor: "pointer",
                      }}
                    >
                      <FaTrash />
                    </button>
                  </div>
                ))
              )}
            </div>
          )}
        </div>

        {/* 🛒 CARRITO */}
        <div
          ref={cartRef}
          style={{
            position: "relative",
            fontSize: "36px",
            cursor: "pointer",
            color: "#333",
          }}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          🛒
          {getCart().length > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-10px",
                right: "-10px",
                background: "red",
                color: "white",
                borderRadius: "50%",
                padding: "4px 8px",
                fontSize: "14px",
              }}
            >
              {getCart().length}
            </span>
          )}

          {dropdownOpen && (
            <div
              style={{
                position: "absolute",
                right: 0,
                top: "45px",
                width: "320px",
                maxHeight: "400px",
                overflowY: "auto",
                backgroundColor: "#fff",
                borderRadius: "12px",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.15)",
                padding: "15px",
                zIndex: 1000,
              }}
            >
              <h4 style={{ marginTop: 0, fontSize: "14px" }}>Carrito</h4>

              {getCart().length === 0 ? (
                <p style={{ fontSize: "12px" }}>Tu carrito está vacío</p>
              ) : (
                <>
                  {getCart().map((item, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px",
                        borderBottom: "1px solid #eee",
                        paddingBottom: "5px",
                      }}
                    >
                      <img
                        src={item.imagen}
                        alt={item.nombre}
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "cover",
                          marginRight: "10px",
                          borderRadius: "5px",
                        }}
                      />
                      <div style={{ flex: 1 }}>
                        <p
                          style={{
                            margin: 0,
                            fontWeight: "bold",
                            fontSize: "12px",
                            color: "black",
                          }}
                        >
                          {item.nombre}
                        </p>
                        <p style={{ margin: 0, fontSize: "12px", color: "black" }}>
                          {(item.precio / 100).toFixed(2)} €
                        </p>
                      </div>

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          removeFromCart(item.nombre);
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          color: "red",
                          cursor: "pointer",
                        }}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  ))}

                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "10px",
                    }}
                  >
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClearCart();
                      }}
                      style={{
                        flex: 1,
                        padding: "8px",
                        backgroundColor: "#f28e8e",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Vaciar
                    </button>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCheckout();
                      }}
                      style={{
                        flex: 1,
                        padding: "8px",
                        backgroundColor: "#4B6CB7",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Pagar
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </div>

      </div>
    </nav>
  );
}

export default Header;
